const question1 = {
    'question': 'Kiedy zdecydować się na psychoterapię?',
    'answer': 'Po pomoc psychoterpeuty warto zgłosić się wtedy, gdy czujesz się samotny, odczuwasz lęk lub niepokój, miewasz stany depresyjne, doświadczasz obniżonego nastroju lub innych stanów psychicznych, które Cię niepokoją. Psychoterapeuta pomoże Ci w kryzysie życiowym oraz wskaże drogę do rozwoju osobistego.',
}

export default question1;